module.exports = __webpack_public_path__ + "static/img/idcardf.8c6e691.png";


//////////////////
// WEBPACK FOOTER
// ./src/summary/assets/images/idcardf.png
// module id = bQMl
// module chunks = 166